


import Header from "../../components/header/index";
import AboutBanner from "./aboutbanner/index";
import AboutContent from "./aboutcontent/aboutContent";
import Values from "./values/value";
import Footer from "../../components/footer";
import Faq from "./faqbox/faqbox";

const aboutus = () => {

  

  return (
    <div className="main">
      <Header />
      <AboutBanner />
      <AboutContent />
      <Values />
      <Faq />
      <Footer />
    </div>
  );
};


export default aboutus;
